import React from 'react';

import styled from '@emotion/styled';

// import LoaderImg from 'assets/Loading.gif';

interface LoaderProps {
  customHeight?: string;
  backgroundColor?: string;
  loaderClass?: string;
}

const StyledLoaderDiv = styled.div<LoaderProps>`
  background-color: red;
  display: flex;
  justify-content: center;
  align-items: center;

  /* @media (max-width: 768px) {
    .loaderImg {
      height: 15%;
    }
  }

  @media (min-width: 768px) {
    .loaderImg {
      height: 25%;
    }
  } */

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const StyledOverlayDiv = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 101;
  background: rgb(0, 0, 0, 0.5);
`;

const StyledLoader = styled.div`
  position: absolute;
  /* top: calc(50% - 30px);
    left: calc(50% - 30px); */
  margin: auto;
  border: 6px solid #969696;
  border-radius: 50%;
  border-top: 6px solid #e4001c;
  width: 48px;
  height: 48px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
    border: 3px solid #969696;
    border-top: 3px solid #e4001c;
  }
`;

const ChatbotLoader = ({ customHeight, backgroundColor, loaderClass = '' }: LoaderProps) => {
  customHeight = customHeight || 'calc(100vh - 65px)';
  backgroundColor = backgroundColor || 'transparent';
  return (
    <StyledLoaderDiv style={{ height: customHeight, backgroundColor: backgroundColor }}>
      {/* <img className='loaderImg' src={LoaderImg} alt='loader-img' /> */}
      <StyledLoader className={loaderClass} />
    </StyledLoaderDiv>
  );
};

export const ChatbotOverlayLoader = ({ customHeight }: LoaderProps) => {
  customHeight = customHeight || '100%';
  return (
    <StyledOverlayDiv>
      <ChatbotLoader backgroundColor='var(--translucent-white)' customHeight={customHeight} />
    </StyledOverlayDiv>
  );
};

export default ChatbotLoader;
